import * as React from "react"
import { cn } from "@/lib/utils"

export interface CircleNumberProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * The number to display
   */
  number: number | string
  /**
   * Background color class (defaults to light gray)
   * Can be any Tailwind background color class (e.g., "bg-blue-100", "bg-gray-100")
   */
  bgColor?: string
  /**
   * Text color class (defaults to gray)
   * Can be any Tailwind text color class (e.g., "text-blue-700", "text-gray-700")
   */
  textColor?: string
}

function CircleNumber({
  className,
  number,
  bgColor = "bg-gray-100 dark:bg-gray-900",
  textColor = "text-gray-700 dark:text-gray-300",
  ...props
}: CircleNumberProps) {
  return (
    <div
      className={cn(
        "flex h-8 w-8 items-center justify-center rounded-full font-medium text-sm",
        bgColor,
        textColor,
        className
      )}
      {...props}
    >
      {number}
    </div>
  )
}

export { CircleNumber }
